export class KaoChiaoError extends Error {
  error;
  constructor(error) {
    super(error);
    this.error = error;
  }
}

export class RequestError extends KaoChiaoError {}

export class NotFoundError extends KaoChiaoError {}
